import PropTypes from "prop-types";
import clsx from "clsx";

import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";

import sectionType from "common/proptypes/section.proptypes";
import Stepper from "features/budget/wizard/views/stepper/stepper.component";
import Clock from "./clock/clock.component";
import HeaderTitle from "./header-title.container";
import headerStyle from "./header.styles";

const useStyles = makeStyles(headerStyle);

function Header({ section, className }) {
  const classes = useStyles();

  return (
    <header className={clsx(classes.header, className)}>
      <Typography
        variant="overline"
        display="block"
        className={classes.subtitle}
      >
        {section.subtitle}
      </Typography>
      <div className={classes.flexRow}>
        <HeaderTitle title={section.title} backTo={section.backTo} />
        {section.withDate ? <Clock /> : null}
        {section.withStepper ? <Stepper /> : null}
      </div>
    </header>
  );
}

Header.propTypes = {
  section: sectionType.isRequired,
  className: PropTypes.string,
};

Header.defaultProps = {
  className: "",
};

export default Header;
